import { Card } from "@/components/ui/card";
import React, { PropsWithChildren } from "react";
import DescriptionItem from "./DescriptionItem";
import DescriptionListContent from "./DescriptionListContent";
import DescriptionListContext from "./DescriptionListContext";
import DescriptionTitle from "./DescriptionTitle";
import DescriptionListHeader from "./DescriptionListHeader";
import DescriptionLink from "./DescriptionLink";
import { NO_DATA } from "@/constants";

interface DescriptionListProps<T extends Record<string, unknown>>
  extends PropsWithChildren {
  data: T;
  translationKey: string;
  actions?: React.ReactNode[];
  variant?: "default" | "ghost";
  className?: string;
}

const DescriptionList = <T extends Record<string, unknown>>({
  children,
  translationKey,
  data,
  variant = "default",
  className,
}: DescriptionListProps<T>) => {
  return (
    <DescriptionListContext.Provider value={{ translationKey, data }}>
      <Card variant={variant} className={className}>
        {children ?? NO_DATA}
      </Card>
    </DescriptionListContext.Provider>
  );
};

export default DescriptionList;

DescriptionList.Item = DescriptionItem;
DescriptionList.Link = DescriptionLink;
DescriptionList.Title = DescriptionTitle;
DescriptionList.Content = DescriptionListContent;
DescriptionList.Header = DescriptionListHeader;
